import React from "react";

const Footer = () => {
  return (
    <div>
      <footer className="text-center footer py-3">
        <div className="footer-list d-flex justify-content-center align-items-center">
          <ul className="d-flex">
            <li> <a href="https://medschoolentry.uk/" className="nav-link" target="_blank"> Terms </a></li>
            <li> <a href="https://medschoolentry.uk/" className="nav-link" target="_blank"> Privacy </a></li>
            <li> <a href="https://medschoolentry.uk/contact" className="nav-link" target="_blank"> Contact </a></li>
          </ul>
        </div>
        <small >© 2025-26 <a href="https://medschoolentry.uk/" className="nav-link d-inline" target="_blank"> medschoolentry.uk</a> | All Rights Reserved. <br />
          Powered by <a href="https://www.efbits.com" className="nav-link d-inline" target="_blank">efbits</a> </small>
      </footer>
    </div>
  );
};

export default Footer;
